module.exports = __webpack_public_path__ + "img/pa@2x.f70c73c2.png";